// AppRoute.js
import React, { Component, Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Detail from './pages/Detail/Detail';
import Search from './pages/Search/Search';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import AccountSettings from './pages/AccountSettings/AccountSettings';
import TvLogin from './pages/TvLogin/TvLogin';
import Price from './pages/Price/Price';
import Watch from './pages/watch/watch';
import Library from './pages/Library/Library';
import Notifications from './pages/Notifications/Notifications';
import AuthGuard from './utils/AuthGuard';
import ProfileGuard from './utils/ProfileGuard';
import DeleteAccount from './pages/DeleteAccount';
import Profiles from './pages/Profiles/Profiles';
import MembershipWatchGuard from './utils/MembershipWatchGuard'; // Premium + Login guard
import {
  AdminLogin,
  AdminDashboard,
  AdminUsers,
  AdminContent,
  AdminPortrait,
  AdminSubscription,
  AdminAnalytics,
  AdminNotifications,
} from './pages/Admin';

class AppRoute extends Component {
  render() {
    return (
      <Fragment>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Login Required */}
          <Route element={<AuthGuard />}>
            <Route path="/profiles" element={<Profiles />} />
            <Route element={<ProfileGuard />}>
              <Route path="/details/:slug" element={<Detail />} />
              <Route path="/search/:key" element={<Search />} />
              <Route path="/profile" element={<AccountSettings />} />
              <Route path="/library" element={<Library />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/tv/setup" element={<TvLogin />} />
              <Route path="/subscricption" element={<Price />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
            </Route>
          </Route>

          {/* Watch Routes */}
          {/* 1. Promo: Public (no login, no membership needed) */}
          {/* <Route path="/watch/promo/:flimId" element={<Watch />} />
          <Route path="/watch/promo/:flimId/:episodeId" element={<Watch />} /> */}

          {/* 2. All other watch types: Require Login + Premium Membership */}
          <Route element={<AuthGuard />}>
            <Route element={<ProfileGuard />}>
              <Route element={<MembershipWatchGuard />}>
                <Route path="/watch/:type/:flimId" element={<Watch />} />
                <Route path="/watch/:type/:flimId/:episodeId" element={<Watch />} />
              </Route>
            </Route>
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/content" element={<AdminContent />} />
          <Route path="/admin/portrait" element={<AdminPortrait />} />
          <Route path="/admin/subscription" element={<AdminSubscription />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/notifications" element={<AdminNotifications />} />
        </Routes>
      </Fragment>
    );
  }
}

export default AppRoute;
